export default {
    // 报警级别信息查询接口
    getAlarmLevel(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarm/getAlarmLevel', params, response);
    },
    // 报警事件信息查询接口
    getAlarmEvent(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarm/getAlarmEvent', params, response);
    },
    // 根据设备类型查询报警事件
    getEventByDeviceType(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarm/getEventByDeviceType', params, response);
    },
    // 保存设备分级
    saveAlarmDeviceClassify(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarm/saveAlarmDeviceClassify', params, response);
    },
    // 查询设备分级
    getAlarmDeviceClassify(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarm/getAlarmDeviceClassify', params, response);
    },
    // 查询树形
    findDeviceTree(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceOrgTree', params, response);
    },
    // 搜索设备
    queryDeviceOrgTreeByName(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceOrgTreeByName', params, response);
    },
    // 获取设备类型下拉列表
    getDeviceTypeList(params, response) {
        window.vue.$apiAxios.get('/alarm/getDeviceTypeList', params, response);
    }
};
